import { supabase } from "./supabase";

// Termos de uso versionados + aceite click-wrap.
//
// A ideia toda: provar QUEM aceitou O QUÊ e QUANDO. O "o quê" é o hash SHA-256
// do texto do termo — se o texto mudar um caractere, o hash muda, e um aceite
// antigo não cola no texto novo. Por isso o texto vive no banco (termo_versoes),
// com um hash gravado, e o aceite (termo_aceites) aponta para aquela versão.
//
// Só COMBUSTÍVEL e MANUTENÇÃO têm termo próprio hoje. Rastreamento entra na
// ficha mas não exige aceite de termo — quando tiver, é só semear a versão.

// sistema da ficha  ->  módulo do termo
// (o CRM chama de "combustivel"; a serverless de "abastecimento" — os dois caem
// no mesmo termo de combustível.)
const SISTEMA_MODULO = {
  manutencao: "MANUTENCAO",
  combustivel: "COMBUSTIVEIS",
  abastecimento: "COMBUSTIVEIS",
};

export const moduloDoSistema = (sis) => SISTEMA_MODULO[sis] || null;

// Rótulo humano do módulo (para a tela e o comprovante)
export const MODULO_LABEL = {
  COMBUSTIVEIS: "Combustível",
  MANUTENCAO: "Manutenção",
};

// Lista de módulos (distintos, com termo) que uma ficha precisa aceitar.
// Mantém a ordem de leitura: manutenção antes de combustível.
export function modulosDaFicha(sistemas) {
  const arr = Array.isArray(sistemas) && sistemas.length ? sistemas : ["manutencao"];
  const mods = [];
  for (const s of arr) {
    const m = moduloDoSistema(s);
    if (m && !mods.includes(m)) mods.push(m);
  }
  return mods;
}

/**
 * Carrega as versões VIGENTES (vigencia_fim IS NULL) dos módulos pedidos.
 * Devolve [] em silêncio se a consulta falhar — a tela decide o fallback, nunca
 * trava o cadastro por causa do termo não ter carregado.
 */
export async function carregarTermosVigentes(modulos) {
  const mods = (modulos || []).filter(Boolean);
  if (!mods.length) return [];
  try {
    const { data, error } = await supabase
      .from("termo_versoes")
      .select("id, modulo, codigo, versao, conteudo_md, hash_sha256, vigencia_inicio")
      .in("modulo", mods)
      .is("vigencia_fim", null);
    if (error || !data) return [];
    // Ordena na mesma ordem pedida (manutenção, combustível)
    return mods.map((m) => data.find((t) => t.modulo === m)).filter(Boolean);
  } catch {
    return [];
  }
}
